import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom"; // Assurez-vous d'avoir React Router installé
import { 
  FaCar, FaLandmark, FaSeedling, FaHandsHelping, FaUniversity, 
  FaGlobe, FaUtensils, FaTheaterMasks, FaRocket, FaBuilding, FaLightbulb, 
  FaBusinessTime,
  FaShieldAlt
} from "react-icons/fa";
import { MdConstruction } from "react-icons/md";

// Liste des catégories avec les icônes mises à jour
const categories = [
  { path: "/mecaniques-et-transformations", icon: FaCar, text: "Mécaniques et transformations", color: "#B0B4B8" },
  { path: "/batiments-et-travaux-publics", icon: MdConstruction, text: "Bâtiments et travaux publics", color: "#FFC107" },
  { path: "/administration-publique", icon: FaLandmark, text: "Administration publique", color: "#673AB7" },
  { path: "/industrie-agricole", icon: FaSeedling, text: "Industrie Agricole et de transformation", color: "#2196F3" },
  { path: "/profession-liberale", icon: () => "⚖️", text: "Profession Libérale", color: "#F44336" },
  { path: "/association-ong-fondations", icon: FaHandsHelping, text: "Association ONG et Fondations", color: "#2196F3" },
  { path: "/societe-cooperative", icon: FaHandsHelping, text: "Société Coopérative", color: "#2196F3" },
  { path: "/etablissement-scolaire", icon: FaUniversity, text: "Établissement Scolaire et Universitaire", color: "#F44336" },
  { path: "/projets-developpement", icon: FaGlobe, text: "Projets de développement", color: "#4CAF50" },
  { path: "/hotellerie-restauration", icon: FaUtensils, text: "Hôtellerie et Restauration", color: "#0D47A1" },
  { path: "/art-culture-divertissement", icon: FaTheaterMasks, text: "Industrie de l'Art, de la Culture et du Divertissement", color: "#0D47A1" },
  { path: "/primo-entrepreneurs", icon: FaRocket, text: "Primo entrepreneurs", color: "#0D47A1" },
  { path: "/immobilier", icon: FaBuilding, text: "Sociétés et agences immobilières", color: "#0D47A1" },
  { path: "/startup", icon: FaLightbulb, text: "Startup", color: "#0D47A1" },
  { path: "/commerce", icon: FaBusinessTime, text: "CommerceGenerale ", color: "#4CAF50" }
];

const CategoriesSection = () => {
  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll(".category-card");
      elements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.8) {
          el.classList.add("visible");
        } else {
          el.classList.remove("visible");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Section>
      <Title>
        CONCENTREZ-VOUS SUR VOTRE COEUR DE MÉTIER, CINEF-EC vous offre des solutions clés en main pour une efficacité accrue
      </Title>
      <Grid>
        {categories.map((cat, index) => {
          const IconComponent = cat.icon;
          return (
            <CategoryLink to={cat.path} key={index}>
              <CategoryCard className="category-card">
                <IconBox bgColor={cat.color}>
                  {typeof IconComponent === "function" ? <IconComponent color="white" size="30px" /> : IconComponent()}
                </IconBox>
                <TextContainer>
                  <Text>{cat.text}</Text>
                </TextContainer>
              </CategoryCard>
            </CategoryLink>
          );
        })}
      </Grid>
    </Section>
  );
};

export default CategoriesSection;

// STYLES
const Section = styled.section`
  text-align: center;
  padding: 50px 10%;
`;

const Title = styled.h2`
  font-size: 1.8rem;
  margin-bottom: 30px;
  color: #333;
`;

const Grid = styled.div`
  display: grid;
  direction: flex;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 20px;
  justify-content: center;
`;

// Nouveau style pour le lien
const CategoryLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: block;
`;

const CategoryCard = styled.div`
  display: flex;
  align-items: stretch;
  background: white;
  border-radius: 8px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out, opacity 0.5s ease-in-out;
  opacity: 0;
  transform: translateY(30px);
  cursor: pointer;
  
  &.visible {
    opacity: 1;
    transform: translateY(0);
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);
  }
`;

const IconBox = styled.div`
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.bgColor || "#ddd"};
`;

const TextContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  padding: 15px;
`;

const Text = styled.p`
  font-size: 1rem;
  color: #333;
  text-align: left;
`;